import React, { Component } from "react";
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

export default class PageVideoSplash extends Component {
    
    componentDidMount() {
    	document.getElementsByClassName('c-video-splash')[0].getElementsByTagName('video')[0].ontimeupdate = (event) => {
	    	if (document.getElementsByClassName('c-video-splash').length !== 0) {
	    		document.getElementsByClassName('c-video-splash')[0].classList.add('state-video-loaded');
	    	}
	    };
	    document.getElementsByClassName('c-video-splash')[0].getElementsByTagName('video')[0].play();
  	}
    
	render () {
		
		let block 	= this.props.block;
		
		if (block) {
	         
		    return (
		        <div id={block.id} className={'c-page__block c-page__block--charcoal c-page__block--transparent'}>
		        	
		        	<div className="c-video-splash">
				    					
			        	<div className="c-video-splash__video c-load-fade" dangerouslySetInnerHTML={{ __html: `
					        <video
					          loop
					          muted
					          autoplay
					          playsInline
					          src="${block.video_background}"
					        />,
						`}}></div>
				        
				        <div className="l-grid">
				        	<div className="l-grid__col">
					        	<h1 className="c-video-splash__heading c-heading c-load-fade" dangerouslySetInnerHTML={{ __html:block.heading}}></h1>
					        
					        	{block.link_url &&
									<Link to={{ pathname: block.link_url}} className="c-video-splash__link c-paragraph c-paragraph--bold c-load-fade">Watch Full Film</Link>
					        	}
				        	</div>
				        </div>
				        
					</div>
			        
				</div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
